import {
  usePaginatedResource,
  useResourceItem,
  useCreateResource,
  useEditResource,
  useDeleteResource,
} from "./useCrudResource"
import {
  getAccountVendors,
  getAccountVendor,
  createAccountVendor,
  updateAccountVendor,
  deleteAccountVendor,
} from "api/accountVendorApi"

export const ACCOUNT_VENDOR_QUERY_KEY = "account-vendors"

export const useAccountVendors = (params = {}, enabled = true) => {
  return usePaginatedResource(
    ACCOUNT_VENDOR_QUERY_KEY,
    getAccountVendors,
    params,
    enabled
  )
}

export const useAccountVendor = (id, enabled = true) => {
  return useResourceItem(ACCOUNT_VENDOR_QUERY_KEY, getAccountVendor, id, enabled)
}

export const useCreateAccountVendor = () => {
  return useCreateResource(createAccountVendor, ACCOUNT_VENDOR_QUERY_KEY)
}

export const useEditAccountVendor = () => {
  return useEditResource(updateAccountVendor, ACCOUNT_VENDOR_QUERY_KEY)
}

export const useDeleteAccountVendor = () => {
  return useDeleteResource(deleteAccountVendor, ACCOUNT_VENDOR_QUERY_KEY)
}
